import React, { useState } from "react";
import "../hoja-de-estilos/TaskList.css"
import Task from "./Task";
import TaskForm from "./TaskForm";


function TaskList(){

  const [tasks, setTasks]= useState([]);

  const addTask = task =>{
    if (task.text.trim()){
      task.text = task.text.trim();
      const allTasks = [task, ...tasks];
      setTasks(allTasks);
    }
  };

  const deleteTask=id=>{
    const allTasks = tasks.filter(task => task.id !== id);
    setTasks(allTasks);
  };

  const completeTask=id=>{
    const newTasks=tasks.map(task=>{
      if (task.id === id){
        task.completed = !task.completed;
      }
      return task;
    });
    setTasks(newTasks);
  };

  return(
    <>
      <TaskForm onSubmit={addTask} />
      <div className="task-list-cont"> 
        {
          tasks.map((task)=>
            <Task 
              key={task.id}
              id={task.id}
              text={task.text} 
              completed={task.completed}
              deleteTask={deleteTask}
              completeTask={completeTask}
            />
          )
        }
      </div>
    </>
  );
}

export default TaskList;